import clsx from "clsx";
import React, { DetailedHTMLProps, HTMLAttributes } from "react";

import { ReactComponent as TopShapeDesktop } from "../images/top-desktop.svg";
import { ReactComponent as TopShapeMobile } from "../images/top-mobile.svg";
import { ParallaxBannerVariants } from "../types";

export interface TopPanelProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  title: string;
  variant: ParallaxBannerVariants;
}

export function TopPanel({ title, variant, ...divProps }: TopPanelProps) {
  const svgClass = {
    "text-neutral": variant === ParallaxBannerVariants.Neutral,
    "text-primary": variant === ParallaxBannerVariants.Primary,
    "text-transparent": variant === ParallaxBannerVariants.Light,
  };

  const titleClass = {
    "text-primary": variant === ParallaxBannerVariants.Neutral,
    "text-neutral":
      variant === ParallaxBannerVariants.Primary || variant === ParallaxBannerVariants.Light,
  };

  return (
    <div {...divProps}>
      <TopShapeDesktop className={clsx("hidden md:block", svgClass)} />
      <TopShapeMobile className={clsx("md:hidden", svgClass)} />
      <div
        className={clsx(
          "absolute top-0 left-0 z-10 flex h-full p-8 3xl:pl-24 lg:px-20 w-full",
          variant !== ParallaxBannerVariants.Light && "items-center pt-0"
        )}
      >
        <h3
          className={clsx(
            "text-2xl lg:text-4xl xl:text-5xl 2xl:text-6xl !font-light lg:w-[68%] leading-normal 2xl:leading-snug",
            variant !== ParallaxBannerVariants.Light && "line-clamp-[5]",
            titleClass
          )}
        >
          {title}
        </h3>
      </div>
    </div>
  );
}
